import React, { useEffect, useRef, useState } from "react";
import { Button, Flex, Grid, Layout } from "antd";
import { Outlet, useNavigate } from "react-router-dom";
import HeaderView from "./HeaderView";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/app";
import Footer from "../../webPages/CommonComponent/Footer";
import PageSpinner from "../../../components/PageSpinner/PageSpinner";
import { Notification } from "../../../config/Global";
import { refreshToken } from "../../../store/AuthSlice";
import { setTranlsation } from "../../../store/CommonSlice";
import SidebarView from "./SidebarView";
import { Header } from "antd/es/layout/layout";
import { CloseOutlined, MenuFoldOutlined, MenuOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { WebConstant } from "../../webPages/webConstant/WebConstant";
import { CONSTANT } from "../../../config/Constant";

/**
 * Renders the main layout of the application with header and footer components with more detail.
 *
 @return {ReactElement} The main layout component.
 */
const MainLayout: React.FC = () => {
  const [collapsed, SetCollapsed] = useState<boolean>(false);
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const [timeOutFlag, setTimeOutFlag] = useState<boolean>(false);
  const [timeInFlag, setTimeInFlag] = useState<boolean>(false);
  const Auth = useSelector((state: RootState) => state.AUTH);

  const sessionTimeoutFlag = useSelector(
    (state: RootState) => state.AUTH.sessionTimeOut
  );
  const logo = useSelector((state: RootState) => state.HOME.pageSettings?.banner?.banner_logo)

  const [loading, setLoading] = useState(true);
  const idleTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  // Code for user to be logged out after 1 hour of inactivity : start
  const idleDuration = CONSTANT.IDEL_TIMEOUT_TIME; // 1 hour in seconds
  useEffect(() => {
    if (!Auth.token) {
      navigate("/login");
      setLoading(false);
    } else {
      if (Auth?.userDetail?.isFreeUser != undefined) {
        if (Auth.userDetail.isFreeUser) {
          navigate("/trial/dashboard");
        }
        setLoading(false);
      }
    }
  }, [Auth.token, Auth.userDetail, navigate, dispatch]);


  window.addEventListener("beforeunload", function () {
    localStorage.setItem("timeOut", new Date().getTime().toString());
  });

  // useEffect(() => {
  //   const timeOut = JSON.parse(localStorage.getItem("timeOut") || "0");
  //   var redirectUrl = "/login"; // Redirect idle users to this URL
  //   if (!sessionTimeoutFlag) {
  //     if (new Date().getTime() - timeOut >= idleDuration * 1000) {
  //       localStorage.removeItem("token");
  //       Notification.error({
  //         message: "Session expired.",
  //       });
  //       const clearTime = setTimeout(() => {
  //         window.location.pathname = redirectUrl;
  //       }, 500);
  //       return () => clearTimeout(clearTime);
  //     }
  //   }
  // }, []);



  useEffect(() => {
    dispatch(setTranlsation({ show: true, className: 'dashboard-translate' }));
    return (() => {
      dispatch(setTranlsation({ show: false, className: '' }));
    })
  }, []);

  useEffect(() => {
    var redirectUrl = "/login"; // Redirect idle users to this URL

    const resetIdleTimeout = () => {

      if (idleTimeoutRef.current) clearTimeout(idleTimeoutRef.current);
      idleTimeoutRef.current = setTimeout(() => {
        if (!timeOutFlag) {
          localStorage.removeItem("token");
          localStorage.removeItem("timeIn");
          setTimeOutFlag(true);
          Notification.error({
            message: "Session expired.",
          });
          const clearTime = setTimeout(() => {
            window.location.pathname = redirectUrl;
          }, 500);
          return () => clearTimeout(clearTime);
        }
      }, idleDuration * 1000);
    };

    resetIdleTimeout();

    const events = ["click", "touchstart", "mousemove"];
    events.forEach((evt) =>
      document.addEventListener(evt, resetIdleTimeout, false)
    );

    // Cleanup event listeners on component unmount
    return () => {
      console.log('idel timepout')
      events.forEach((evt) =>
        document.removeEventListener(evt, resetIdleTimeout, false)
      );
      if (idleTimeoutRef.current) clearTimeout(idleTimeoutRef.current);
    };
  }, [timeOutFlag]);
  // Code for user to be logged out after 1 hour of inactivity : end	

  // Code for refresh token :Start
  // useEffect(() => {

    // const checkInterval = 1 * 60 * 60;
    // const tokenRefreshTime = 1 * 60 * 60; //Duration of time in seconds
    // const nextRefresh = 21 * 60 * 60;
  

    // const isWithin0To10PercentHigher = (value1: any, value2: any) => {
    //   if (value2 === 0) {
    //     throw new Error("Division by zero is not allowed");
    //   }

    //   if (value1 < value2) {
    //     return false;
    //   }

    //   const result = Math.abs(value1 / value2);
    //   const subtractionResult = result - Math.floor(result);
    //   return subtractionResult >= 0 && subtractionResult <= 0.1;
    // }

    // const intervalId = setInterval(() => {

      // setTimeInFlag(true);
      // dispatch(refreshToken());
      // Set a timeout to reset the flag after the specified seconds
      // setTimeout(() => {
      //   setTimeInFlag(false);
      // }, nextRefresh * 1000);
      // }
    // }, checkInterval * 1000);

    // const timeIn = JSON.parse(localStorage.getItem("timeIn") || "0");
    // const elapsedSeconds = Math.round((new Date().getTime() - Number(timeIn)) / 1000);
    // let timeoutId: any;
    // if (timeIn != 0 && elapsedSeconds > tokenRefreshTime) {
    //   timeoutId = setTimeout(() => {
    //     dispatch(refreshToken());
    //   }, 6000);
    // }


    // return () => {
      // clearInterval(intervalId)
      // clearTimeout(timeoutId)
    // }; // Cleanup on unmount
  // }, [timeInFlag]);

  // Code for refresh token :End
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  return !loading ? (
    <Layout className={`main__page__wrapper has__appsidebar`}>


      {((screens.sm && !screens.md) || screens.xs) && <Header style={{ padding: 0, background: 'white' }}>
        <Flex justify="space-between" align="center">
          <div className="headerWrap logo-left-head">
            <div className="app_header_left">
              <div className="logoImg" onClick={() => navigate("/login")}>
                <img className="icon" src={WebConstant?.IMAGE_URL + logo} alt="logo" />
              </div>
            </div>

          </div>
          <div>
            {collapsed ? <MenuOutlined className="mobile-hamberg-menu" onClick={() => SetCollapsed(!collapsed)} /> : <CloseOutlined className="mobile-hamberg-menu" onClick={() => SetCollapsed(!collapsed)} />}
          </div>
        </Flex>

      </Header>}


      <Layout className="site-layout">
        <SidebarView collapsed={collapsed} SetCollapsed={SetCollapsed} />
        {/* <HeaderView collapsed={collapsed} SetCollapsed={SetCollapsed} /> */}
        <Layout.Content className="main__app__content" style={!collapsed && ((screens.sm && !screens.md) || screens.xs) ? { overflow: 'hidden', height: '90vh' } : {}}>
          <Outlet />
        </Layout.Content>
        {/* <Footer /> */}
      </Layout>
    </Layout >
  ) : (
    <PageSpinner />
  );
};

export default MainLayout;
